import { Component, Inject, OnInit } from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import {validationmethod} from '../../../shared/common/validationmethod';
import {LocalStorageSettingsService} from '../../../shared/services/local-storage-settings.service';
import {CommonService} from '../../../shared/services/common.service';
import {ErrorMessages} from '../../../shared/common/errormessages';
import {AsignUserRoleService} from '../../../shared/services/asign-user-role.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {constants} from '../../../shared/common/contants';
import { TrnxCommonService } from 'src/app/shared/services/trnx-common.service';
import { ConstantPool } from '@angular/compiler';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { RestApi } from 'src/app/shared/RestApi/restApi';


interface trnxCommonServiceInfo {
  statusMessage: any;
  error: boolean;
  data: any;
}



export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  remarksData: any;
  childId: any;
}
@Component({
    selector: 'app-access-management-popup',
    templateUrl: './access-management-popup.component.html',
    styleUrls: ['./access-management-popup.component.scss'],
    standalone: false
})
/*
  Author-Abhishek T
  10-10-2023
  for Access management for all the dnses
*/
export class AccessManagementPopupComponent implements OnInit {
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  FormValid: UntypedFormGroup;
  formValidCheckbox: UntypedFormGroup;
  isCheckboxSelected=false;
  showCreateAnother=true;
  validation_messages: any;
  backgroundColorButton = '';
  userRoleNameData: any;
  bpCompnayId: any;
  userrolesmstrid: '';
  usersData: any;
  companyData: any;
  acessmanagement = {
    
    'userid': [],
    'dnsId': '',
    'type': '',
    'companyid':'',
    
  };
  
  userid: '';
  buttonName: any;
  materialData: any;
  isroleassigned: any;

  constructor(private restAPI: RestApi,private http: HttpClient,public dialogref: MatDialogRef<AccessManagementPopupComponent>, private validation: validationmethod, private localStorageSettings: LocalStorageSettingsService,private commonservice:CommonService,
              private commonService: CommonService, private errorMsg: ErrorMessages, private asignUserRoleService: AsignUserRoleService, private spinner: NgxUiLoaderService, private snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData, private constants: constants) {
    this.validation_messages = this.errorMsg.concreteUpdateReportMessages;
  }

  ngOnInit() {
    console.log('edata');
    console.log(this.data.edata);
    console.log(this.data.edata.assignuserroleid);
    console.log();

    this.formValidationsCheckbox();

    this.formvalidations();
    if (this.data.edata.dnsId != undefined) {
      this.acessmanagement = {
       
        'userid': this.data.edata.userid,
        'dnsId': this.data.edata.dnsId,
        'type': '',
        'companyid':this.data.edata.companyid,
       
      };
      
      this.FormValid.get('dnsId').disable();
      this.FormValid.get('companyid').disable();
      this.buttonName = 'Update';
      this.showCreateAnother = false;
      this.DropdownCompany();
     this.Dropdown(this.acessmanagement.companyid)
      this.retriveUser(this.acessmanagement.dnsId)
    } else {
      this.buttonName = 'Save';
      this.showCreateAnother = true;
    }
    console.log(this.materialData);
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    this.DropdownCompany();
    //this.Dropdown();
    

  }

  formValidationsCheckbox() {
  this.formValidCheckbox = new UntypedFormGroup({
    isCheckboxSelected: new UntypedFormControl(false)
  });
}
 
  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      'dnsId': new UntypedFormControl('', [Validators.required]),
      'userid': new UntypedFormControl('', [Validators.required]),
      'companyid': new UntypedFormControl('', [Validators.required]),
    });
  }
/*
  Adeed by-Abhishek T
  10-10-2023
  for Retrive the dns records while pop up opens
*/
  async Dropdown(compid) {
    var tenantId = this.localStorageSettings.getSettings('dnsName');
    //reteriveing users by dnsId
    this.spinner.start()
    this.commonService.retrieveDnsService(compid).subscribe(response=>
    {

      console.log(response)

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        return null;

      }
      else {

        this.spinner.stop();

        this.userRoleNameData = response;
        console.log(this.userRoleNameData) 
        // this.retriveUser(this.userRoleNameData[0].vaultconfigmstrid)
        this.retriveUser(this.userRoleNameData[0].id)


      }

    });

    console.log('userRoleNameData');
    console.log(this.userRoleNameData);

   
  }
/*
  Author-Abhishek T
  10-10-2023
  for retrive the user list after selecting dhs 
*/
  async retriveUser(dnsId){
    console.log(dnsId);
     //retrieve Users For Assign User Role
     this.commonService.retrieveDnsUser(dnsId).subscribe(response => {
      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, 'OK', {duration: 5000});


      } else {

        this.spinner.stop();

        this.usersData = response;

      }
    });

  }
  /*
  Author-Abhishek T
  10-10-2023
  for save or update the records
*/
  //updating and inserting data for assign user role
  async updateData() {
    const selectedDnsId = this. acessmanagement.dnsId;
    const selectedUserIds = this. acessmanagement.userid;
    this.FormValid.markAllAsTouched();
    if(this. acessmanagement.userid.length<=0){
      this.snackBar.open("Select atleast one user", 'OK', {duration: 50000});
      return;
    }
    this.acessmanagement.type =  this.buttonName;
    console.log(selectedDnsId);
    console.log(selectedUserIds);
    this.commonService.saveDnsUser(this.acessmanagement).subscribe(response => {
      if (response.error == true) {
        console.log('inside error');
        console.log(response);
        this.spinner.stop();
        this.dialogref.close();
        this.snackBar.open(response.statusMessage, 'OK', {duration: 5000});

      } else {

        this.spinner.stop();
        // this.dialogref.close();
        this.snackBar.open(response.statusMessage, 'OK', {duration: 50000});
         if (!this.isCheckboxSelected) {
        // Close popup if "Create Another" not checked
        this.dialogref.close();
      } else {
        // Reset form for creating another record
        this.acessmanagement = {
          userid: [],
          dnsId: '',
          type: '',
          companyid: ''
        };
        this.FormValid.reset();
      }
      }
    });
 
    

  }

  

  close() {
    this.dialogref.close();
  }

  
  async DropdownCompany() {
    var tenantId = this.localStorageSettings.getSettings('dnsName');
    //reteriveing users by dnsId
    this.spinner.start()

    console.log('userRoleNameData');
    console.log(this.userRoleNameData);

    

    let response = await this.http.get<trnxCommonServiceInfo>(this.restAPI.GET_TRNX_TABLE_DATA_FOR_DROPDOWNS + "/" + "company" + "/" + "compname", { headers: this.headers }).toPromise();
    console.log(response)
    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

    }
    else {

      this.spinner.stop();

      this.companyData = response;



    }

  }

}
